$(document).ready(function(){
  var slider;
  var mainSlider;
  //myModal
  $('#product-redirect-modal').submit(function(e){
    if ($('.container input').is(":checked")){
      $('.close').click();
      $(".error-text").text("");
    } else {
      $(".error-text").text("Please review and confirm Terms & Conditions");
      e.preventDefault();
    }
  });
  $('#myModal .carousel-indicators .nums').click(function(){

  });
  $('#myModal .carousel-indicators .nums').click(function(){
    clearInterval(mainSlider);
    var width = $( window ).width();
    if(width > 768){
      $("#myModal .carousel-indicators .nums").removeClass("active");
      $(this).addClass("active");
      $("#myModal .carousel-inner .item").removeClass("active");
      var num = $(this).attr('id');
      $("#myModal .desktop-listbox #listbox-" + num + "").addClass("active");
    } else {
      $("#myModal .carousel-indicators .nums").removeClass("active");
      $(this).addClass("active");
      var num = $(this).attr('id');
      $("#myModal .modal-header").removeClass("active");
      $("#myModal #mobile-modal-header-" + num + "").addClass("active");
      $("#myModal .mobile-listbox .item").removeClass("active");
      $("#myModal .mobile-listbox #listbox-" + num + "").addClass("active");
      $("#myModal .mobile-img").removeClass("active");
      $("#myModal #mobile-bottom-slider-" + num + "").addClass("active");
    }
    
  });
   $('#myModal #left-carousel').click(function(){
    clearInterval(mainSlider);
     var current = $("#myModal .carousel-indicators-numbers .nums.active").attr("id");
    var current_num = parseInt(current.split("-")[1]);
     if(current_num == 1){
       return;
     } else {
       $('#myModal .carousel-indicators #carousel-' + (current_num-1)).click();
     }
  });
  $('#myModal #right-carousel').click(function(){
    clearInterval(mainSlider);
    var current = $("#myModal .carousel-indicators-numbers .nums.active").attr("id");
    var current_num = parseInt(current.split("-")[1]);
    console.log(current_num);
     if(current_num == 4){
       return;
     } else {
       $('#myModal .carousel-indicators #carousel-' + (current_num+1)).click();
     }
  });
  $('#myModal #left-mobile-carousel').click(function(){
    var current = $("#myModal .mobile-img.active").attr("id");
    var current_num = parseInt(current.split("-")[4]);
     if(current_num == 1){
      $("#myModal .mobile-img").removeClass("active");
      $('#myModal #mobile-bottom-slider-carousel-3').addClass("active");
     } else {
      $("#myModal .mobile-img").removeClass("active");
       $('#myModal #mobile-bottom-slider-carousel-' + (current_num-1)).addClass("active");
     }
  });
  $('#myModal #right-mobile-carousel').click(function(){
    var current = $("#myModal .mobile-img.active").attr("id");
    var current_num = parseInt(current.split("-")[4]);
     if(current_num == 3){
      $("#myModal .mobile-img").removeClass("active");
      $('#myModal #mobile-bottom-slider-carousel-1').addClass("active");
     } else {
      $("#myModal .mobile-img").removeClass("active");
      $('#myModal #mobile-bottom-slider-carousel-' + (current_num+1)).addClass("active");
     }
  });
  mainSlider = setInterval(function(){
    var current = $("#myModal .carousel-indicators-numbers .nums.active").attr("id");
    var current_num = parseInt(current.split("-")[1]);
     if(current_num == 4){
      $("#myModal .carousel-indicators .nums").removeClass("active");
      $('#myModal .carousel-indicators #carousel-1').addClass("active");
      $("#myModal .item").removeClass("active");
      $("#myModal #listbox-carousel-1").addClass("active");
     } else {
      $("#myModal .carousel-indicators .nums").removeClass("active");
       $('#myModal .carousel-indicators #carousel-' + (current_num+1)).addClass("active");
       $("#myModal .item").removeClass("active");
      $("#myModal #listbox-carousel-" + (current_num+1) + "").addClass("active");
     }
  }, 3000);
  
  //signModal
  $('#signModal .carousel-indicators .nums').click(function(){
    clearInterval(slider);
    var width = $( window ).width();
    if(width > 768){
      $("#signModal .carousel-indicators .nums").removeClass("active");
      $(this).addClass("active");
      $("#signModal .carousel-inner .item").removeClass("active");
      var num = $(this).attr('id');
      $("#signModal .desktop-listbox #listbox-" + num + "").addClass("active");
    } else {
      $("#signModal .carousel-indicators .nums").removeClass("active");
      $(this).addClass("active");
      var num = $(this).attr('id');
      $("#signModal .mobile-listbox .item").removeClass("active");
      $("#signModal .mobile-listbox #listbox-" + num + "").addClass("active");
      $("#signModal .mobile-img").removeClass("active");
      $("#signModal #mobile-bottom-slider-" + num + "").addClass("active");
    }
  });
   $('#signModal #left-sign-carousel').click(function(){
    clearInterval(slider);
     var current = $("#signModal .carousel-indicators-numbers .nums.active").attr("id");
    var current_num = parseInt(current.split("-")[2]);
     if(current_num == 1){
       return;
     } else {
      $("#signModal .carousel-indicators .nums").removeClass("active");
       $('#signModal .carousel-indicators #sign-carousel-' + (current_num-1)).addClass("active");
       $('#signModal .carousel-indicators #sign-carousel-' + (current_num-1)).trigger('click');
     }
  });
  $('#signModal #right-sign-carousel').click(function(){
    clearInterval(slider);
    var current = $("#signModal .carousel-indicators-numbers .nums.active").attr("id");
    var current_num = parseInt(current.split("-")[2]);
     if(current_num == 4){
       return;
     } else {
      $("#signModal .carousel-indicators .nums").removeClass("active");
       $('#signModal .carousel-indicators #sign-carousel-' + (current_num+1)).addClass("active");
       $('#signModal .carousel-indicators #sign-carousel-' + (current_num+1)).trigger('click');
     }
  });
  $('#signModal #left-sign-mobile-carousel').click(function(){
    
    var current = $("#signModal .mobile-img.active").attr("id");
    var current_num = parseInt(current.split("-")[5]);
     if(current_num == 1){
      $("#signModal .mobile-img").removeClass("active");
      $('#signModal #mobile-bottom-slider-sign-carousel-3').addClass("active");
     } else {
      $("#signModal .mobile-img").removeClass("active");
       $('#signModal #mobile-bottom-slider-sign-carousel-' + (current_num-1)).addClass("active");
     }
  });
  $('#signModal #right-sign-mobile-carousel').click(function(){
    
    var current = $("#signModal .mobile-img.active").attr("id");
    var current_num = parseInt(current.split("-")[5]);
     if(current_num == 3){
      $("#signModal .mobile-img").removeClass("active");
      $('#signModal #mobile-bottom-slider-sign-carousel-1').addClass("active");
     } else {
      $("#signModal .mobile-img").removeClass("active");
      $('#signModal #mobile-bottom-slider-sign-carousel-' + (current_num+1)).addClass("active");
     }
  });  

  slider = setInterval(function(){
    var current = $("#signModal .carousel-indicators-numbers .nums.active").attr("id");
    var current_num = parseInt(current.split("-")[2]);
     if(current_num == 4){
      $("#signModal .carousel-indicators .nums").removeClass("active");
      $('#signModal .carousel-indicators #sign-carousel-1').addClass("active");
      $("#signModal .item").removeClass("active");
      $("#signModal #listbox-sign-carousel-1").addClass("active");
     } else {
      $("#signModal .carousel-indicators .nums").removeClass("active");
       $('#signModal .carousel-indicators #sign-carousel-' + (current_num+1)).addClass("active");
       $("#signModal .item").removeClass("active");
      $("#signModal #listbox-sign-carousel-" + (current_num+1) + "").addClass("active");
     }
  }, 3000);
});

